
<div class="multipleLikeButton" @click="toggle">
  <i class="icon" :class="{ 'bookmark': checked, 'bookmark outline': !checked }"></i>
  <div class="text">保存</div>
  <div v-if="$root.selectedShopCount" class="ui floating circular label">{{ $root.selectedShopCount }}</div>
</div>
